<template>
  <card>
    <list
      v-if="$store.state.user.is_root"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "holiday",
      fields: [
        {
          key: "title",
          label: "Название",
          isMultiLang: true,
          type: "field",
        },
        {
          key: "description",
          label: "Краткое описание",
          isMultiLang: true,
          type: "textarea",
        },
        {
          key: "date",
          label: "День",
          type: "date",
          textType: "number",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_holiday",
      itemLink: "holidays",
      setLink: "holidays",
      columns: [
        {
          key: "title",
          title: "Название",
        },
        {
          key: "description",
          title: "description",
          label: "description_holiday",
          lang: true,
        },
        {
          key: "date",
          title: "date",
          label: "date_holiday",
          dateFormat: true,
          lang: true,
        },

        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
